import axios from 'axios';

export default {
  async getListPromotion(context) {
    try {
      const userToken = context.rootGetters['user/getUserToken'];
      let is_authorize = false;
      if (userToken) {
        is_authorize = true;
      }
      let response = await axios.get(
        `${process.env.API_BASE_URL}/promotion/list?channel_code=B2CONLINE&is_authorize=${is_authorize}`
      );
      const { data } = response.data;
      context.commit('listPromotions', data);
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async detailPromotion(context, { datas, callback }) {
    try {
      let response = await axios.get(`${process.env.API_BASE_URL}/promotion/get?code=${datas.value}`);
      const { data } = response.data;
      context.commit('promoDetail', data);
      callback(data);
    } catch (error) {
      const errorResponse = error.response;
      return errorResponse;
    }
  },
  async searchingPromoCode(context, { datas }) {
    try {
      let response = await axios.get(
        `${process.env.API_BASE_URL}/promotion/search?channel_code=B2CONLINE&code=${datas.value}`
      );
      const { data } = response.data;
      context.commit('listPromotions', data);
      return data;
    } catch (error) {
      return error.response;
    }
  },
  async redeemPromo(context, params) {
    const token = context.rootGetters['policy/getPurchaseConfirmation'].token;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    try {
      const link = `${process.env.API_BASE_URL}/smartphone/promo/check`;
      const { data } = await axios.post(link, params, config);
      const result = data.data;
      Object.assign(result, {
        is_used: result.status === 'CHECK'
      });
      context.commit('usePromoCode', result);
      return result;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  },
  async checkPromoCode(context, params) {
    try {
      const userToken = context.rootGetters['user/getUserToken'];
      if (userToken) {
        params.is_authorize = true;
      } else {
        params.is_authorize = false;
      }
      const link = `${process.env.API_BASE_URL}/promotion/check`;
      const { data } = await axios.post(link, params);
      const result = data.data;
      Object.assign(result, {
        is_used: result.status === 'CHECK'
      });
      context.commit('updatePromoCalculation', result);
      return result;
    } catch (error) {
      const errorResponse = error.response;
      const errorData = (errorResponse || {}).data;
      return errorData;
    }
  }
};
